import { DarkModeButton } from 'atoms/DarkModeButton';
import LanguageSwitcher from 'atoms/LanguageSwitcher';
import { cvtClassName } from 'commons/utils';

export const AppFooter = () => {
  const footerBaseClass = [
    'fixed',
    'bottom-0',
    'left-0',
    'w-full',
    'py-5',
    'px-3',
    'text-clamp_s',
    'text-[--c-text]',
    'bg-[--c-footer-background]',
  ];

  const footerClass = [
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'border-t-2',
    'border-solid',
    'border-[--c-line]',
    'h-16',
  ];

  return (
    <>
      <div className="pb-20">
        <footer className={cvtClassName(footerBaseClass)}>
          <div className={cvtClassName(footerClass)}>
            <div className="flex flex-col items-center justify-center w-full">
              <div className="flex items-center justify-center pt-5 gap-4">
                <DarkModeButton sx={{ mx: 1 }}></DarkModeButton>
              </div>
              <p className="text-center">
                © Sony Music Entertainment (Japan) Inc. All rights reserved.
              </p>
              <a
                className="ot-sdk-show-settings text-sm underline cursor-pointer"
                href="#ot-sdk-btn"
              >
                Cookies Settings
              </a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};
